module.exports = __webpack_public_path__ + "img/hotel2.0f317ff6.png";